import { render, staticRenderFns } from "./CrateMaster.vue?vue&type=template&id=6581e448&scoped=true"
import script from "./CrateMaster.vue?vue&type=script&lang=js"
export * from "./CrateMaster.vue?vue&type=script&lang=js"
import style0 from "./CrateMaster.vue?vue&type=style&index=0&id=6581e448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581e448",
  null
  
)

export default component.exports